var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrganization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 45.5H10C5.16 45.5 2.5 42.84 2.5 38V22C2.5 17.16 5.16 14.5 10 14.5H20C20.82 14.5 21.5 15.18 21.5 16V38C21.5 41.16 22.84 42.5 26 42.5C26.82 42.5 27.5 43.18 27.5 44C27.5 44.82 26.82 45.5 26 45.5ZM10 17.5C6.84 17.5 5.5 18.84 5.5 22V38C5.5 41.16 6.84 42.5 10 42.5H19.6C18.88 41.32 18.5 39.82 18.5 38V17.5H10Z",
    fill: "#455CC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17.5H10C9.18 17.5 8.5 16.82 8.5 16V12C8.5 8.96 10.96 6.5 14 6.5H20.22C20.68 6.5 21.12 6.71996 21.4 7.07996C21.68 7.45996 21.78 7.94 21.66 8.38C21.54 8.82 21.5 9.32 21.5 10V16C21.5 16.82 20.82 17.5 20 17.5ZM11.5 14.5H18.5V10C18.5 9.82 18.5 9.66 18.5 9.5H14C12.62 9.5 11.5 10.62 11.5 12V14.5Z",
    fill: "#455CC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 27.5C27.18 27.5 26.5 26.82 26.5 26V16C26.5 15.18 27.18 14.5 28 14.5C28.82 14.5 29.5 15.18 29.5 16V26C29.5 26.82 28.82 27.5 28 27.5Z",
    fill: "#455CC7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36 27.5C35.18 27.5 34.5 26.82 34.5 26V16C34.5 15.18 35.18 14.5 36 14.5C36.82 14.5 37.5 15.18 37.5 16V26C37.5 26.82 36.82 27.5 36 27.5Z",
    fill: "#455CC7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36 45.5H28C27.18 45.5 26.5 44.82 26.5 44V36C26.5 34.08 28.08 32.5 30 32.5H34C35.92 32.5 37.5 34.08 37.5 36V44C37.5 44.82 36.82 45.5 36 45.5ZM29.5 42.5H34.5V36C34.5 35.72 34.28 35.5 34 35.5H30C29.72 35.5 29.5 35.72 29.5 36V42.5Z",
    fill: "#455CC7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 35.5C11.18 35.5 10.5 34.82 10.5 34V26C10.5 25.18 11.18 24.5 12 24.5C12.82 24.5 13.5 25.18 13.5 26V34C13.5 34.82 12.82 35.5 12 35.5Z",
    fill: "#455CC7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38 45.5H26C21.16 45.5 18.5 42.84 18.5 38V10C18.5 5.16 21.16 2.5 26 2.5H38C42.84 2.5 45.5 5.16 45.5 10V38C45.5 42.84 42.84 45.5 38 45.5ZM26 5.5C22.84 5.5 21.5 6.84 21.5 10V38C21.5 41.16 22.84 42.5 26 42.5H38C41.16 42.5 42.5 41.16 42.5 38V10C42.5 6.84 41.16 5.5 38 5.5H26Z",
    fill: "#455CC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganization);
export default __webpack_public_path__ + "static/media/Organization.95d17645.svg";
export { ForwardRef as ReactComponent };